import { Box, Icon, Typography } from "@mui/material"
import { icons } from "../../../utils/icons"
import { useStyles } from "./styles"

function NoResponse({ label }:{label: string}) {
    const styles = useStyles()
    return (
        <Box sx={styles.noResponse}>
            <Icon>{icons('error')}</Icon>

            <Typography variant="subtitle" fontWeight='500'>{label}</Typography>
        </Box>
    )
}

export { NoResponse }